import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Trans, useTranslation } from "react-i18next";
import tag_color from "../../assets/media/icons/tag-color.svg";
import cross_invert_color from "../../assets/media/icons/cross-invert-color.svg";
import HackedMDBSelect from "./hackedmdbselect";
export const sortKeys = [
    { text: "Name (a - z)", value: "name_asc" },
    { text: "Name (z - a)", value: "name_desc" },
    { text: "Size (smaller - larger)", value: "size_asc" },
    { text: "Size (larger - smaller)", value: "size_desc" },
    { text: "Date (earlier - later)", value: "date_asc" },
    { text: "Date (later - earlier)", value: "date_desc" },
];
export const sortBy = (tree, select) => {
    if (tree === undefined) {
        return undefined;
    }
    else {
        const copiedTree = { ...tree };
        if (copiedTree.content === undefined || copiedTree.content.length === 0) {
            return copiedTree;
        }
        copiedTree.content = [];
        for (const child of tree.content) {
            const sortedChild = sortBy(child, select);
            copiedTree.content.push(sortedChild);
        }
        copiedTree.content = shallowSort(copiedTree.content, select);
        return copiedTree;
    }
};
const shallowSort = (array, select) => {
    if (array === undefined) {
        return undefined;
    }
    else if (array.length === 0) {
        return [];
    }
    else {
        const tmpSorted = [...array];
        if (select === "name_asc") {
            tmpSorted.sort((a, b) => {
                const aName = a.value ?? a.properties.fileName;
                const bName = b.value ?? b.properties.fileName;
                return aName.toLowerCase().localeCompare(bName.toLowerCase());
            });
        }
        else if (select === "name_desc") {
            tmpSorted.sort((a, b) => {
                const aName = a.value ?? a.properties.fileName;
                const bName = b.value ?? b.properties.fileName;
                return bName.toLowerCase().localeCompare(aName.toLowerCase());
            });
        }
        else if (select === "size_asc") {
            tmpSorted.sort((a, b) => {
                const ret = sortFoldersFirst(a, b);
                if (ret !== undefined) {
                    return ret;
                }
                return a.properties.fileSize - b.properties.fileSize;
            });
        }
        else if (select === "size_desc") {
            tmpSorted.sort((a, b) => {
                const ret = sortFoldersFirst(a, b);
                if (ret !== undefined) {
                    return ret;
                }
                return b.properties.fileSize - a.properties.fileSize;
            });
        }
        else if (select === "date_asc") {
            tmpSorted.sort((a, b) => {
                const ret = sortFoldersFirst(a, b);
                if (ret !== undefined) {
                    return ret;
                }
                return a.properties.creationTime - b.properties.creationTime;
            });
        }
        else if (select === "date_desc") {
            tmpSorted.sort((a, b) => {
                const ret = sortFoldersFirst(a, b);
                if (ret !== undefined) {
                    return ret;
                }
                return b.properties.creationTime - a.properties.creationTime;
            });
        }
        else {
            tmpSorted.sort((a, b) => {
                return sortFoldersFirst(a, b) ?? 0;
            });
        }
        return tmpSorted;
    }
};
const sortFoldersFirst = (a, b) => {
    if (isFolder(a)) {
        if (isFolder(b)) {
            return 0;
        }
        else {
            return -1;
        }
    }
    else {
        if (isFolder(b)) {
            return 1;
        }
        else {
            return undefined;
        }
    }
};
const isFolder = (a) => {
    return (a.content !== undefined && a.content.length > 0) || a.properties.isFile === false;
};
export function SortFilterSetter(props) {
    const { t, i18n } = useTranslation();
    function getSelectedValueAsString(singleSelectValue) {
        if (singleSelectValue === undefined) {
            return undefined;
        }
        let selectValue;
        if (typeof singleSelectValue === "number") {
            selectValue = singleSelectValue.toString();
        }
        else {
            selectValue = singleSelectValue;
        }
        return selectValue;
    }
    function translateOptions(orig) {
        return orig.map((l) => ({
            ...l,
            text: t(l.text ?? "N/A"),
        }));
    }
    return (_jsxs(_Fragment, { children: [_jsx(HackedMDBSelect, { data: translateOptions(props.sortKeys), value: props.selectedValue, onValueChange: (select) => {
                    if (select === undefined) {
                        props.sorterFunction(undefined);
                    }
                    else {
                        if (!Array.isArray(select)) {
                            const singleSelect = select;
                            const selectValue = getSelectedValueAsString(singleSelect.value);
                            props.sorterFunction(selectValue);
                        }
                        else {
                            const multiSelect = select;
                            const selectValue = getSelectedValueAsString(multiSelect[0].value);
                            props.sorterFunction(selectValue);
                        }
                    }
                }, label: _jsxs("div", { className: props.selectedValue ? "multiselect-div" : "multiselect-div inactive", children: [_jsx("svg", { width: "16", height: "16", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: _jsx("path", { d: "M6.85342 5.85348C6.80701 5.89992 6.7519 5.93675 6.69125 5.96189C6.63059 5.98702 6.56558 5.99996 6.49992 5.99996C6.43427 5.99996 6.36926 5.98702 6.3086 5.96189C6.24795 5.93675 6.19284 5.89992 6.14642 5.85348L4.99994 4.70701L4.99982 12.5001C4.99982 12.6327 4.94716 12.7598 4.85341 12.8536C4.75966 12.9473 4.63251 13 4.49992 13C4.36734 13 4.24019 12.9473 4.14644 12.8536C4.05269 12.7598 4.00002 12.6327 4.00002 12.5001L3.99994 4.70701L2.85342 5.85348C2.75967 5.94723 2.63251 5.9999 2.49992 5.9999C2.36734 5.9999 2.24018 5.94723 2.14642 5.85348C2.05267 5.75972 2 5.63256 2 5.49998C2 5.36739 2.05267 5.24023 2.14642 5.14648L4.14642 3.14648C4.19284 3.10004 4.24795 3.0632 4.3086 3.03807C4.36926 3.01294 4.43427 3 4.49992 3C4.56558 3 4.63059 3.01294 4.69125 3.03807C4.7519 3.0632 4.80701 3.10004 4.85342 3.14648L6.85342 5.14648C6.89986 5.19289 6.9367 5.248 6.96183 5.30865C6.98697 5.36931 6.9999 5.43432 6.9999 5.49998C6.9999 5.56563 6.98697 5.63065 6.96183 5.6913C6.9367 5.75195 6.89986 5.80706 6.85342 5.85348ZM13.8534 10.1465C13.807 10.1 13.7519 10.0632 13.6912 10.0381C13.6306 10.0129 13.5656 10 13.4999 10C13.4343 10 13.3693 10.0129 13.3086 10.0381C13.2479 10.0632 13.1928 10.1 13.1464 10.1465L11.9999 11.293L11.9998 3.49991C11.9998 3.36732 11.9472 3.24017 11.8534 3.14642C11.7597 3.05267 11.6325 3.00001 11.4999 3.00001C11.3673 3.00001 11.2402 3.05267 11.1464 3.14642C11.0527 3.24017 11 3.36732 11 3.49991L10.9999 11.293L9.85343 10.1465C9.75967 10.0528 9.63251 10.0001 9.49992 10.0001C9.36734 10.0001 9.24018 10.0528 9.14642 10.1465C9.05267 10.2403 9 10.3674 9 10.5C9 10.6326 9.05267 10.7598 9.14642 10.8535L11.1464 12.8535C11.1928 12.8999 11.2479 12.9368 11.3086 12.9619C11.3693 12.987 11.4343 13 11.4999 13C11.5656 13 11.6306 12.987 11.6912 12.9619C11.7519 12.9368 11.807 12.8999 11.8534 12.8535L13.8534 10.8535C13.8999 10.8071 13.9367 10.752 13.9618 10.6913C13.987 10.6307 13.9999 10.5657 13.9999 10.5C13.9999 10.4344 13.987 10.3693 13.9618 10.3087C13.9367 10.248 13.8999 10.1929 13.8534 10.1465V10.1465Z", fill: "#ffffff" }) }), _jsx("span", { children: "Sort" })] }) }), props.selectedValue && (_jsx("button", { className: "button subtle medium", onClick: () => {
                    props.sorterFunction(undefined);
                }, children: _jsx("svg", { width: "16", height: "16", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: _jsx("path", { d: "M8.70703 8L13.8535 2.85352C14.0488 2.6582 14.0488 2.3418 13.8535 2.14648C13.6582 1.95117 13.3418 1.95117 13.1465 2.14648L8 7.29297L2.85352 2.14648C2.6582 1.95117 2.3418 1.95117 2.14648 2.14648C1.95117 2.3418 1.95117 2.6582 2.14648 2.85352L7.29297 8L2.14648 13.1465C1.95117 13.3418 1.95117 13.6582 2.14648 13.8535C2.24414 13.9512 2.37207 14 2.5 14C2.62793 14 2.75586 13.9512 2.85352 13.8535L8 8.70703L13.1465 13.8535C13.2441 13.9512 13.3721 14 13.5 14C13.6279 14 13.7559 13.9512 13.8535 13.8535C14.0488 13.6582 14.0488 13.3418 13.8535 13.1465L8.70703 8Z", fill: "#ffffff" }) }) }))] }));
}
export function SortFilterDisplay(props) {
    const { t, i18n } = useTranslation();
    if (props.selectedKey === undefined) {
        return false;
    }
    else {
        const result = sortKeys.find((item) => item.value === props.selectedKey);
        if (result === undefined) {
            return false;
        }
        return (_jsxs(_Fragment, { children: [_jsxs("div", { className: "filter-div-explorer", children: [_jsxs("span", { className: "filter-title", children: [_jsx(Trans, { children: "Sorting" }), ":"] }), _jsxs("div", { className: "tags-div-2", children: [_jsx("img", { src: tag_color, alt: "tag" }), _jsx("span", { children: t(result.text) }), _jsx("img", { src: cross_invert_color, alt: "cross-invert" })] })] }), window.innerWidth > 992 && _jsx("div", { className: "spacer" })] }));
    }
}
